import React from "react";
import Navbar from "../../components/Navbar/navbar";
import NetZeroNavBar from "../../components/Net-Zero-Components/Net-Zero-Navbar/net-zero-navbar";
import PageInfoDialog from "../../components/PageInfoDialog/PageInfoDialog";
import { PAGE_INFO_DATA } from "../../utils/pageInfoData";

function NetZeroDashboard() {
  return (
    <>
      {/* Page Info Icon - Fixed Position Top Right */}
      <PageInfoDialog pageData={PAGE_INFO_DATA['net-zero']} pageKey="net-zero" />
      
      <Navbar />
      <NetZeroNavBar />
    </>
  );
}

export default NetZeroDashboard;
